<template>
  <vue-pdf-app :pdf="pdf" @open="openHandler" @pages-rendered="pagesRenderedHandler" :config="config" :fileName="name" :theme="darkMode ? 'dark': 'light' ">
  </vue-pdf-app>
</template>

<script>
// VuePdfApp component is registered in src/main.js
import { i18n } from '@/i18n'

export default {
  name: 'PDFViewerApp',
  props: {
    pdf: {
      default: null,
    },
    name: {
      type: String,
      default: `${i18n.tc('app.documents', 1).toLowerCase()}.pdf`,
    },
    search: {
      type: String,
      default: null,
    }
  },
  methods: {
    openHandler (pdfApp) {
      // window._pdfApp = pdfApp
      pdfApp.setTitleUsingUrl(this.name)
      document.body.classList.remove('loadingInProgress')
    },
    pagesRenderedHandler (pdfApp) {
      pdfApp.setTitleUsingUrl(this.name)
      setTimeout(() => (pdfApp.pdfViewer.currentPageNumber = 1))
      this.searchContent()
    },
    searchContent () {
      if (this.search) {
        document.getElementById('viewFind').click()
        document.getElementById('findInput').value = this.search
        document.getElementById('findHighlightAll').click()
      }
      this.$emit('pdfViewerOpenHandler')
    },
  },
  data () {
    return {
      config: {
        sidebar: {
          viewThumbnail: true,
          viewOutline: true,
          viewAttachments: true,
        },
        secondaryToolbar: {
          secondaryPresentationMode: true,
          secondaryOpenFile: false,
          secondaryPrint: false,
          secondaryDownload: false,
          secondaryViewBookmark: false,
          firstPage: true,
          lastPage: true,
          pageRotateCw: true,
          pageRotateCcw: true,
          cursorSelectTool: true,
          cursorHandTool: true,
          scrollVertical: true,
          scrollHorizontal: true,
          scrollWrapped: true,
          spreadNone: true,
          spreadOdd: true,
          spreadEven: true,
          documentProperties: true,
        },
        toolbar: {
          toolbarViewerLeft: {
            findbar: true,
            previous: false,
            next: false,
            pageNumber: true,
          },
          toolbarViewerRight: {
            presentationMode: true,
            openFile: false,
            print: false,
            download: false,
            viewBookmark: false,
          },
          toolbarViewerMiddle: {
            zoomOut: true,
            zoomIn: true,
            scaleSelectContainer: true,
          },
        },
        errorWrapper: true,
      }
    }
  },
  computed: {
    darkMode: function () {
      return !!this.$store.getters['app/darkMode']
    },
  }
}
</script>

<style scoped>
::v-deep.pdf-app.light{
  --pdf-app-background-color:var(--primary-50);
  --pdf-sidebar-content-color:rgba(0, 0, 0, 0.1);
  --pdf-toolbar-sidebar-color:var(--primary-100);
  --pdf-toolbar-color:var(--primary-100);
  --pdf-loading-bar-color:var(--secondary-DEFAULT);
  --pdf-loading-bar-secondary-color: var(--primary-DEFAULT);
  --pdf-find-results-count-color:var(--primary-DEFAULT);
  --pdf-find-results-count-font-color:#525252;
  --pdf-find-message-font-color:#525252;
  --pdf-not-found-color:#f66;
  --pdf-split-toolbar-button-separator-color:var(--darkblue-400);
  --pdf-toolbar-font-color:var(--secondary-DEFAULT);
  --pdf-button-hover-font-color:var(--primary-DEFAULT);
  --pdf-button-toggled-color:var(--primary-200);
  --pdf-horizontal-toolbar-separator-color:var(--darkblue-400);
  --pdf-input-color:var(--primary-200);
  --pdf-input-font-color:var(--secondary-DEFAULT);
  --pdf-find-input-placeholder-font-color:var(--primary-DEFAULT);
  --pdf-thumbnail-selection-ring-color:hsla(0, 0, 55%, 0.15);
  --pdf-thumbnail-selection-ring-selected-color:hsla(0, 0%, 50%, 0.3);
  --pdf-error-wrapper-color:#f55;
  --pdf-error-more-info-color:var(--secondary-DEFAULT);
  --pdf-error-more-info-font-color:#000;
  --pdf-overlay-container-color:rgba(0,0,0,0.2);
  --pdf-overlay-container-dialog-color:var(--primary-100);
  --pdf-overlay-container-dialog-font-color:var(--secondary-DEFAULT);
  --pdf-overlay-container-dialog-separator-color:var(--darkblue-400);
  --pdf-dialog-button-font-color:var(--secondary-DEFAULT);
  --pdf-dialog-button-color:var(--primary-200);
  }

::v-deep.pdf-app.dark{
  --pdf-app-background-color:var(--darkblue-DEFAULT);
  --pdf-sidebar-content-color:rgba(0, 0, 0, 0.1);
  --pdf-toolbar-sidebar-color:var(--darkblue-600);
  --pdf-toolbar-color:var(--darkblue-600);
  --pdf-loading-bar-color:var(--darkblue-500);
  --pdf-loading-bar-secondary-color: var(--primary-DEFAULT);
  --pdf-find-results-count-color:var(--darkblue-100);
  --pdf-find-results-count-font-color:#525252;
  --pdf-find-message-font-color:#525252;
  --pdf-not-found-color:#f66;
  --pdf-split-toolbar-button-separator-color:#fff;
  --pdf-toolbar-font-color:var(--darkblue-100);
  --pdf-button-hover-font-color:var(--primary-DEFAULT);
  --pdf-button-toggled-color:var(--darkblue-500);
  --pdf-horizontal-toolbar-separator-color:#fff;
  --pdf-input-color:var(--darkblue-500);
  --pdf-input-font-color:var(--darkblue-100);
  --pdf-find-input-placeholder-font-color:#11ece5;
  --pdf-thumbnail-selection-ring-color:hsla(0,0%,100%,0.15);
  --pdf-thumbnail-selection-ring-selected-color:hsla(0, 0%, 100%, 0.3);
  --pdf-error-wrapper-color:#f55;
  --pdf-error-more-info-color:var(--darkblue-100);
  --pdf-error-more-info-font-color:#000;
  --pdf-overlay-container-color:rgba(0,0,0,0.2);
  --pdf-overlay-container-dialog-color:var(--darkblue-600);
  --pdf-overlay-container-dialog-font-color:var(--darkblue-100);
  --pdf-overlay-container-dialog-separator-color:#fff;
  --pdf-dialog-button-font-color:var(--darkblue-100);
  --pdf-dialog-button-color:var(--darkblue-500);
  }
</style>
